import { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext({
  notifyInfo: (title, msg) => {},
  notifyWarn: (title, msg) => {},
  notifyError: (title, msg) => {},
});

export function useNotify() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const add = useCallback((type, title, message) => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, type, title, message }]);
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 4000);
  }, []);

  const notifyInfo = useCallback((title, message) => add('info', title, message), [add]);
  const notifyWarn = useCallback((title, message) => add('warn', title, message), [add]);
  const notifyError = useCallback((title, message) => add('error', title, message), [add]);

  return (
    <NotificationContext.Provider value={{ notifyInfo, notifyWarn, notifyError }}>
      {children}
      {/* Toast container */}
      <div className="fixed bottom-4 right-4 z-50 space-y-2">
        {notifications.map(n => (
          <div key={n.id}
            className="px-4 py-3 rounded-xl shadow-lg text-sm max-w-sm animate-slide-up"
            style={{
              backgroundColor: n.type === 'error' ? '#fef2f2' : n.type === 'warn' ? '#fef3c7' : '#f0f9ff',
              border: `1px solid ${n.type === 'error' ? '#fca5a5' : n.type === 'warn' ? '#fde68a' : '#93c5fd'}`,
              color: n.type === 'error' ? '#991b1b' : n.type === 'warn' ? '#92400e' : '#1e40af',
            }}>
            <p className="font-semibold">{n.title}</p>
            {n.message && <p className="text-xs mt-0.5 opacity-80">{n.message}</p>}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}
